/*
 * Форматирует дату в формат DD MMMM YYYY (25 января 2020)
 *
 * @param {Date} date
 * */
export var formatDateLong = function formatDateLong(date) {
  return date.toLocaleDateString('ru-RU', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  }).slice(0, -3);
};